import * as React from 'react';
import LoadingWithMessage from '../../misc/components/LoadingWithMessage';

interface InstructionStep {
    Key: number;
    Value: string;
}

export interface DeviceInstructionModel {
    Steps: Array<InstructionStep>;
    Title: string;
    Image: string;
}

export interface DeviceInstructionProps {
    isFetching: boolean;
    instructions: DeviceInstructionModel;
}

export const DeviceInstruction = ({ isFetching, instructions }: DeviceInstructionProps) => {
    if (isFetching) {
        return (<LoadingWithMessage message="Loading Device Instructions..." />);
    } else if (instructions !== undefined) {
        const steps = instructions.Steps;
        const listItems = steps.map((step) => <li key={step.Key}>{step.Value}</li>);

        return (
            <div className="row">
                <div className="col-md-12">
                    <h2 className="text-primary">{instructions.Title}</h2>
                </div>
                <div className="col-md-12">
                    <ul className="posh-list">
                        {listItems}
                    </ul>
                </div>
                <div className="col-md-12 text-center">
                    <img style={{ width: 100 + '%', maxWidth: 500 + 'px' }} src={instructions.Image} alt="" />
                </div>
            </div>
        );
    } else {
        return null;
    }
}
